import { Modal } from "Components/Modal";
import { Body1 } from "melodies-source/Text";

interface ConfirmLiveEditProps {
  isOpen?: boolean;
  onClose?: VoidFunction;
  onConfirm?: VoidFunction;
}

export const ConfirmLiveEdit = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmLiveEditProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="Edit Live Campaign?"
      actions={{
        main: { text: "Edit Campaign", onClick: onConfirm, variant: "primary" },
        secondary: { text: "Cancel", onClick: onClose, variant: "tertiary" },
      }}
    >
      <Body1>
        Please be aware that some changes, like removing a question or response
        option, will make any data you've already collected for those items
        permanently inaccessible in this campaign’s reporting.
        <br />
        <br />
        You will have the option to hide these items instead to continue viewing
        this reporting data.
      </Body1>
    </Modal>
  );
};
